const getSign = (value: number) => {
    // eslint-disable-next-line no-compare-neg-zero
    if (!value || value === 0 || value === -0) return 0;
    return Math.abs(value) / value;
};

export default getSign;
